import React from "react";
import { TableRow, TableCell, Typography } from "@mui/material";

export default function EmptyStateRow({ colSpan = 1, text = "رکوردی یافت نشد." }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      </TableCell>
    </TableRow>
  );
}


